module.exports = "./img/0e3260f5d741241816eb13051bba652c.jpg";